export default "__VITE_ASSET__a3bf28e8__"